import { getStoreId } from "$/hooks/use-store-information"
import tireStorageQueries from "$/lib/queries/tire-storage-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/tire-hotel")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(tireStorageQueries.settings(storeId))
    }

    return {
      crumb: "alfred.settings.nav.tireHotel.label",
    }
  },
})
